import React, { useState } from "react";
import Part_iStyle from "./part_i.module.css";
import { Button, Select, Table } from "antd";
import { ReactComponent as DownIcon } from "../../../../assets/icon/下载.svg";


import styled from "styled-components";
import * as XLSX from 'xlsx';
import { ColumsArr,methylation_summary,ButtonArr } from "./methylation_summary";
const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: #e3f2d9; // 修改表头背景颜色
    color: #333; // 修改表头文字颜色
    font-weight: bold; // 修改表头文字加粗
  }
`;
function Parrt_I() {
  const [ButtonVal,setButtonVal]=useState("P18")

  // 下载CSV文件
  const handleDownloadCSV = () => {
    // 获取当前显示的数据，优先显示过滤后的数据
    const dataToExport = methylation_summary[ButtonVal].length > 0 ? methylation_summary[ButtonVal] : methylation_summary;
    
    // 使用 XLSX 将数据转换为 CSV
    const ws = XLSX.utils.json_to_sheet(dataToExport);  // 将 JSON 转换为工作表
    const csv = XLSX.utils.sheet_to_csv(ws); // 转换为 CSV 字符串

    // 创建一个 Blob 对象并触发下载
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${ButtonVal}.csv`; // 下载文件的名字
    link.click();  // 触发下载
  };
  return (
    <div>
      {/* <div className={Part_iStyle.DNA_methylation_search_Form_div}>
        <p className={Part_iStyle.DNA_meth_label}>
          Choose Projects:
        </p>
        <div>
          {
            ButtonArr.map(v=>{
              return  <Button
              style={{
                margin:"0 10px",
                width:"80px",
                backgroundColor:v===ButtonVal?"#BDF7C1":"white"
              }}
              onClick={()=>{
                setButtonVal(v)
              }}
              >{v}</Button>
            })
          }
         
        </div>
      </div> */}
      <div className={Part_iStyle.DNA_methylation_search}>
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* <p style={{fontWeight:"bold"}}>Epigenetic Methylation Differences in Cotyledon Development of Lotus Seeds</p> */}
        <Select
        defaultValue={'Epigenetic Methylation Differences in Cotyledon Development of Lotus Seeds'}
        options={[
          {
            key:"Epigenetic Methylation Differences in Cotyledon Development of Lotus Seeds",
            label:"Epigenetic Methylation Differences in Cotyledon Development of Lotus Seeds",
            value:"Epigenetic Methylation Differences in Cotyledon Development of Lotus Seeds"
          }
        ]}
        />
        </div>
        <Button
          style={{
            display: "flex",
            alignItems: "center",
            border: "none",
          }}
          onClick={handleDownloadCSV}
        >
          <DownIcon width={20} />{" "}
          <span
            style={{
              margin: "0 10px",
              fontFamily: "SourceHanSansSC-regular",
            }}
          >
            CSV
          </span>
        </Button>
      </div>
      <StyledTable
        bordered
        style={{ width: "95%", margin: "20px auto" }}
      columns={ColumsArr}
      dataSource={methylation_summary[ButtonVal]}
      />
      
    </div>
  );
}

export default Parrt_I;
